import { Injector, NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { TableSortService } from "./services/table-sort.service";
import { MenuModule } from "./menu/menu.module";
import { environment } from "../environments/environment";
import { CalAngularModule } from "@cvx/cal-angular";
import { AppRoutingModule } from "./app-routing.module";
import { TokenInterceptor } from "./interceptors/token-interceptor";
import { DatePipe } from "@angular/common";
import { AssetHierarchyModule } from "./asset-hierarchy/asset-hierarchy.module";
import { TurbinesModule } from "./turbines/turbines.module";
import { HelpModule } from "./help/help.module";
import { HomeModule } from "./home/home.module";
import { RamTargetsModule } from "./ram-targets/ram-targets.module";
import { TechnicalLettersModule } from "./technical-letters/technical-letters.module";
import { SharedModule } from "./shared.module";

const componentList = [AppComponent];

@NgModule({
  declarations: [componentList],
  imports: [
    HttpClientModule,
    MenuModule,
    AppRoutingModule,
    AssetHierarchyModule,
    TurbinesModule,
    HelpModule,
    HomeModule,
    RamTargetsModule,
    TechnicalLettersModule,
    SharedModule,
    CalAngularModule.forRoot({
      autoSignIn: true,
      popupForLogin: false,
      cacheLocation: "localStorage",
      instance: "https://login.microsoftonline.com/",
      tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
      clientId: environment.clientId,
      redirectUri: "/auth",
      oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
      graphScopes: ["User.Read", "User.Read.All", "Group.Read.All"],
    }),
  ],
  exports: [],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    TableSortService,
    DatePipe,
  ],
})
export class AppTest {
  constructor(private injector: Injector) {}
}
